import React from 'react';

import { ListState } from 'react-stately';
import { PulseLoader } from 'components/loaders';
import Spacer from 'components/Spacer';
import { ListVariant } from '../types';
import * as S from './styles';

type LoaderRowProps = {
  state: ListState<unknown>;
  showDivider?: boolean;
  variant: ListVariant;
};

const LoaderRow = React.forwardRef<HTMLDivElement, LoaderRowProps>(
  ({ state, showDivider, variant }, ref) => {
    return (
      <S.LoaderRoot $variant={variant} ref={ref}>
        {state.collection.size !== 0 && showDivider && <S.RowDivider />}
        <S.GridCell>
          <Spacer justify="center">
            <PulseLoader />
          </Spacer>
        </S.GridCell>
      </S.LoaderRoot>
    );
  },
);

export default LoaderRow;
